<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M20.793 9.806L17 6.013v19.975l3.793-3.793a1 1 0 111.414 1.415l-5.382 5.382a1.167 1.167 0 01-1.65 0l-5.382-5.383a1 1 0 111.414-1.414L15 25.988V6.013l-3.793 3.793a1 1 0 11-1.414-1.414l5.382-5.382a1.167 1.167 0 011.65 0l5.382 5.382a1 1 0 01-1.414 1.414z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsVerticalOutline'
}
</script>
